module.exports = __webpack_public_path__ + "media/images/logo/zorg-id-484be1e715b6c6df4fd4e0ee933c7cb3.png";